const DEFAULT_APP_SCHEME = "worldcupadp";
const ANDROID_PACKAGE = "com.adp.flutter_starter_kit";

/** Mismo host que invitaciones (`join`), que ya abre la app en Android. */
export const PASSWORD_RESET_FLOW = "reset-password";

export function buildCustomSchemeUrl(
  host: string,
  token: string,
  scheme = DEFAULT_APP_SCHEME,
): string {
  return `${scheme}://${host}?token=${encodeURIComponent(token)}`;
}

/** Deep link de reset: reutiliza host `join` + flow (igual patrón probado en invitaciones). */
export function buildPasswordResetAppUrl(token: string): string {
  return `${DEFAULT_APP_SCHEME}://join?flow=${PASSWORD_RESET_FLOW}&token=${encodeURIComponent(token)}`;
}

export function buildAndroidIntentUrl(
  customSchemeUrl: string,
  browserFallbackUrl: string,
): string {
  const [scheme, rest] = customSchemeUrl.split("://");
  if (!scheme || !rest) return customSchemeUrl;

  return `intent://${rest}#Intent;scheme=${scheme};package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(browserFallbackUrl)};end`;
}

export function openMobileAppDeepLink(customSchemeUrl: string, browserFallbackUrl: string) {
  const isAndroid = /Android/i.test(navigator.userAgent);
  const targetUrl = isAndroid
    ? buildAndroidIntentUrl(customSchemeUrl, browserFallbackUrl)
    : customSchemeUrl;

  window.location.href = targetUrl;
}

export function isMobileUserAgent(userAgent = navigator.userAgent): boolean {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
}
